import type { FunctionComponent } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import ReactTooltip from 'react-tooltip';
import { Button } from '@fff-web/fff-ui-shared';
import { getTrackingUrl } from '../../../utils/orders';
import * as styles from './styles.module.scss';

type ShipmentDetailsType = {
  carrier?: string;
  trackingNumber?: string;
  orderShipmentId?: string;
  carrierTrackingUrl?: string;
};
type ShipmentHeaderType = {
  title?: string;
  subtitle: string;
  shipmentDetails?: ShipmentDetailsType;
  trackShipment: (trackingNumber: string) => void;
};

const ShipmentHeader: FunctionComponent<ShipmentHeaderType> = ({
  title = null,
  subtitle,
  shipmentDetails = {},
  trackShipment,
}) => {
  const { shipmentTracking: shipmentTrackingFF } = useFlags();
  const trackingUrl = getTrackingUrl(shipmentDetails, shipmentTrackingFF);
  const showUnavailableButton = title === 'Drop Ship';

  const handleClickTrackShipment = () => {
    trackShipment(shipmentDetails.trackingNumber, 'Shipment Tracked');
    window.open(trackingUrl, '_blank');
  };

  return (
    <div className={styles.header} data-testid="shipment-header-container">
      <div>
        <h2>{title}</h2>
        <h3>{subtitle}</h3>
      </div>
      {trackingUrl && (
        <div className={styles.buttonContainer}>
          <Button
            variation="black"
            containerFullWidth
            onClick={handleClickTrackShipment}
            data-testid="track-shipment-button"
          >
            Track Shipment
          </Button>
        </div>
      )}
      {showUnavailableButton && (
        <>
          <div className={styles.dropship} data-testid="dropship-container">
            <div
              className={styles.unavailable}
              data-tip="This product will ship directly from the retailer and separately from the rest of your order."
              data-for="unavailable"
            >
              <Button variation="black" containerFullWidth disabled>
                Tracking Link Unavailable
              </Button>
            </div>
            <p>
              <a
                href="https://support.fabfitfun.com/en/articles/22-what-is-a-drop-ship-item"
                target="_blank"
                rel="noreferrer"
              >
                Click here
              </a>{' '}
              for more information.
            </p>
          </div>
          <ReactTooltip id="unavailable" type="dark" effect="solid" className={styles.tooltip} />
        </>
      )}
    </div>
  );
};

export default ShipmentHeader;
